// bi 广告扩展相关

/**
 * 获取抢券有 so 广告位信息
 * @returns
 */
export function getWecouponAdInfo() {
  return {
    fdpId: sessionStorage.getItem('wecoupn_ad_key') || '',
  };
}
